import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  Box,
  Tooltip,
  Divider,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import CloseIcon from '@mui/icons-material/Close';
import logo from '../assets/productreview.jpg';
import LogoutIcon from '@mui/icons-material/Logout';

function Navbar() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [logoOpen, setLogoOpen] = useState(false);

  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  const username = localStorage.getItem('username');

  const handleMenu = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleLogoClick = () => setLogoOpen(true);
  const handleLogoClose = () => setLogoOpen(false);

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('username');
    setAnchorEl(null);
    window.location.href = '/signin';
  };

  return (
    <>
      <AppBar position="sticky" elevation={3} sx={{ backgroundColor: '#616161', xs:{px: 2} }}>
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          {/* Left: Logo + Title */}
          <Box
            display="flex"
            alignItems="center"
            sx={{
              ml: { xs: 0, sm: 1 },
              pl: { xs: 0, sm: 1 },
            }}
          >
            <IconButton onClick={handleLogoClick} sx={{ p: { xs: 0, sm: 1 } }}>
              <Avatar
                src={logo}
                alt="Logo"
                sx={{
                  width: { xs: 32, sm: 48 },
                  height: { xs: 32, sm: 48 },
                  border: '2px solid white',
                }}
              />
            </IconButton>

            <Typography
              variant="h6"
              sx={{
                color: 'white',
                fontWeight: 'bold',
                fontSize: { xs: '1rem', sm: '1.4rem' },
                ml: 1,
              }}
            >
              Product Review Hub
            </Typography>
          </Box>

          {/* Right: Account Menu */}
          <Box>
            <Tooltip title="Account Options">
              <IconButton onClick={handleMenu} color="inherit">
                <Box display="flex" alignItems="center">
                  {isLoggedIn && (
                    <Typography sx={{ mr: 1, color: 'white', fontWeight: 500 }}>
                      {username}
                    </Typography>
                  )}
                  <AccountCircle fontSize="large" />
                </Box>
              </IconButton>
            </Tooltip>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              PaperProps={{
                sx: {
                  mt: 1,
                  borderRadius: 2,
                  boxShadow: 4,
                  minWidth: 180,
                },
              }}
            >
              {isLoggedIn ? (
                <MenuItem onClick={handleLogout}>
                  <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
                  Logout
                </MenuItem>
              ) : (
                <>
                  <MenuItem onClick={handleClose} component="a" href="/signin">
                    Sign In
                  </MenuItem>
                  <Divider />
                  <MenuItem onClick={handleClose} component="a" href="/signin">
                    Sign Up
                  </MenuItem>
                </>
              )}
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Logo Popup */}
      <Dialog open={logoOpen} onClose={handleLogoClose} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ textAlign: 'center', fontWeight: 600 }}>
          Product Review Logo
          <IconButton
            onClick={handleLogoClose}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
          <Avatar
            src={logo}
            alt="Logo"
            sx={{ width: 150, height: 150, border: '4px solid #2C3E50' }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}

export default Navbar;
